
const muiTheme = {
  palette: {
    // primary: {main: 'rgb(0, 154, 60)'},
    primary: { main: '#114598' },
    secondary: { main: '#487ba9' },
    pickerHeaderColor: {main: 'rgb(0, 154, 60)'}
  }
};

export default muiTheme;